import React from 'react';
import {
    PhoneIcon,
    EnvelopeIcon,
    MapPinIcon
} from '@heroicons/react/24/outline';

const Contact = () => {
    const contactInfo = [
        {
            icon: PhoneIcon,
            title: 'Telefon',
            info: '+90 555 145 66 21',
            link: 'tel:+905551456621'
        },
        {
            icon: EnvelopeIcon,
            title: 'E-posta',
            info: 'bilgi.sagtek@gmail.com',
            link: 'mailto:bilgi.sagtek@gmail.com'
        },
        {
            icon: MapPinIcon,
            title: 'Adres',
            info: 'Batman Teknokent Kat: 1 No: 101',
            link: 'https://maps.app.goo.gl/your-location-link'
        }
    ];

    return (
        <section id="contact" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12 sm:mb-16">
                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                        Bizimle İletişime Geçin
                    </h2>
                    <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
                        Projeleriniz hakkında konuşmak için bizimle iletişime geçin
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
                    <div>
                        <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-6 sm:mb-8">
                            Bize Ulaşın
                        </h3>

                        <div className="space-y-6">
                            {contactInfo.map((item, index) => (
                                <div key={index} className="flex items-start">
                                    <div className="flex items-center justify-center w-12 h-12 bg-primary-100 rounded-lg mr-4 flex-shrink-0">
                                        <item.icon className="h-6 w-6 text-primary-500" />
                                    </div>
                                    <div>
                                        <h4 className="text-base sm:text-lg font-medium text-gray-900 mb-1">
                                            {item.title}
                                        </h4>
                                        <a
                                            href={item.link}
                                            target={item.link.startsWith('http') ? '_blank' : undefined}
                                            rel={item.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                                            className="text-sm sm:text-base text-gray-600 hover:text-primary-500 transition-colors duration-200"
                                        >
                                            {item.info}
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="bg-white rounded-xl shadow-lg overflow-hidden h-96 lg:h-auto">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3152.7076289071333!2d41.06479807573579!3d37.79689107197975!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x400b3debc898a003%3A0xa314378e83da421f!2sBatman%20Teknokent!5e0!3m2!1str!2str!4v1761211110695!5m2!1str!2str"
                            width="100%"
                            height="100%"
                            style={{ border: 0, minHeight: '400px' }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Batman Teknokent Harita"
                        ></iframe>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
